export const Notification = {
  "Adding": "Adding...",
  "AddingInfo": "It will be done in a short time.",
  "AddSuccess": "Success Added",
  "AddSuccessInfo": "The settings have been applied.",
  "AddFailed": "Add Failed",
  "FailedInfo": "Please try again later.",
  "Converting": "Converting...",
  "ConvertingExportImages": "Exporting...",
  "ConvertingInfo": "We are working on the conversion.",
  "ConvertingInfoExportImages": "We are working on exporting images.",
  "Combining": "Combining...",
  "CombiningInfo": "We are working hard to merge.",
  "DownloadFile": "Downloading...",
  "DownloadFileInfo": "We are working hard to download",
  "DownloadFileSuccess": "Download successful",
  "DownloadFileSuccessInfo": "Your file has been downloaded.",
  "ConvertSuccess": "Conversion successful",
  "ConvertSuccessExportImages": "Success",
  "FileUploadSucceeded": "File upload succeeded",
  "FileUploadFailed": "File upload failed",
  "SaveAgain": "Save again",
  "FileUploading": "Your file is uploading to {fromDrive}.",
  "SavedToSharePoint": "Your file has been saved to your {fromDrive} account.",
  "SavedToSharePointFailed": "Failed to save your file to your {fromDrive} account.",
  "ConvertSuccessInfo": "Your file has been converted.",
  "ConvertSuccessInfoExportImages": "All images have been exported.",
  "ConvertFailed": "Conversion Failed",
  "ConvertFailedExportImages": "Failed",
  "Cancel": "Cancel",
  "Download": "Download",
  "Open": "Open",
  "CombineSuccess": "We are working hard to merge.",
  "CombineSuccessInfo": "Your files have been merged",
  "FormFieldsFound": "Form fields found",
  "ContainForm": "This document contains interactive form fields.",
  "Recognition": {
    "Title": "Text Recognition",
    "Content": "Some pages may contain unrecognized text. You can run text recognition to make text searchable or editable."
  },
  "enableEdit": "Enable Editing",
  "disableEdit": "Disable Editing",
  "PdfADocument": "PDF/A Compliance",
  "pdfaDocumentNotice": "The current file is compliant with PDF/A. Click \"Enable Editing\" to never open in PDF/A mode. Click \"Disable Editing\" to view documents in PDF/A view mode (i.e. read-only mode) to prevent modifications.",
  "UntrustedSignatureInfo": "Document has signatures from signers you haven't trusted yet. Press Manage Trust to review and trust these signers.",
  "NotYetVerified": "At least one signature requires validating.",
  "AllValid": "Signed and all signatures are valid.",
  "HasInValid": "At least one signature is invalid.",
  "HasProblemInSignature": "At least one signature has problems.",
  "certifyNotTrustInfo": "The validity of the document certification is UNKNOWN.\nThe author could not be verified.",
  "certifyValidInfo": "Certified by {signer} {email}, {orgName} certificate issued by {issuer}.",
  "manageTrustBtn": "Manage Trust",
  "signaturePanelBtn": "Signature Panel",
  "comfirm": "Confirm",
  "pdfaeiditinfor": "Editing a PDF will cause the PDF to no longer comply with PDF/A. Are you sure you wish to continue?",
  "NoCountry": "Foxit Account supports Country field now. Please go to <a id='goToMyCount' class=\"text-purple\" >My Account</a> to fill in your country information. Your country information will be used to determine which region's data center is used to store your shared file for Foxit PDF Editor Cloud.",
  "NoCountryContent": "",
  "hasUsData": "Please visit <a class=\"text-purple\" href=\"{URL}\" target=\"_blank\">{URL}</a> to download or delete your historical data/files stored in Foxit US data center."
}
